import { render, staticRenderFns } from "./V1.vue?vue&type=template&id=a4be305a&scoped=true"
import script from "./V1.vue?vue&type=script&lang=js"
export * from "./V1.vue?vue&type=script&lang=js"
import style0 from "./V1.vue?vue&type=style&index=0&id=a4be305a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4be305a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonComponent: require('/home/luiz/Sistemas/loja/components/ButtonComponent.vue').default})
